import { render, staticRenderFns } from "./TagAction.vue?vue&type=template&id=5c18aef6&scoped=true&"
import script from "./TagAction.vue?vue&type=script&lang=js&"
export * from "./TagAction.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./TagAction.vue?vue&type=style&index=1&id=5c18aef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c18aef6",
  null
  
)

export default component.exports